// A stable, opaque per-browser "device" id.
//
// This is the unit of "does the Ubik desktop app run HERE?". We mint a random
// UUID once per browser profile and keep it in localStorage. During the desktop
// auth handoff the web app hands this id to the overlay, which then advertises
// it back to the backend (X-Ubik-Device-Id) on every authenticated call. The
// meetings-page install check then asks the backend "is a desktop registered
// for THIS device id?" — a plain authenticated API call, instead of probing the
// overlay's loopback server (which HTTPS pages can't reach reliably: Private
// Network Access on Chrome, mixed content on Safari).
//
// The id is a random token, never a fingerprint. Its scope is one browser
// profile — the same scope the old install cache used, so this is no narrower.

const DEVICE_ID_KEY = "ubik:device-id";

// Fallback when localStorage is unavailable (private-mode Safari, storage
// disabled): a per-tab id so the handoff still carries something and nothing
// throws. It won't persist across reloads, but it never crashes the flow.
let _memoryId: string | null = null;

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    if (!_memoryId) _memoryId = crypto.randomUUID();
    return _memoryId;
  }
}
